module.exports = __webpack_public_path__ + "img/86.0821d97f.png";